<template>
    <div id="tooltip-modal" :style="{ top: tooltipTop + 'px', left: tooltipLeft + 'px' }"></div>
</template>

<script>
export default {
  data() {
    return {
      tooltipTop: 0,
      tooltipLeft: 0
    };
  },
  mounted() {
    this.addEventListenersToTooltips();
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList.contains('tooltip')) {
            this.addEventListenersToTooltip(node);
          }
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  },
  methods: {
    addEventListenersToTooltips() {
      const tooltips = document.querySelectorAll('.tooltip');
      tooltips.forEach(tooltip => {
        this.addEventListenersToTooltip(tooltip);
      });
    },
    addEventListenersToTooltip(tooltip) {
      tooltip.addEventListener('mouseenter', this.showTooltip);
      tooltip.addEventListener('mouseleave', this.hideTooltip);
    },
    showTooltip(event) {
      const tooltip = document.querySelector('#tooltip-modal');
      tooltip.style.display = 'block';
      const target = event.target;
      if (!target.hasAttribute('data-title-text')) {
        const titleText = target.getAttribute('title');
        target.setAttribute('data-title-text', titleText);
        target.removeAttribute('title');
      }
      tooltip.innerHTML = target.getAttribute('data-title-text');
      const targetRect = target.getBoundingClientRect();
      this.tooltipTop = targetRect.bottom;
      this.tooltipLeft = targetRect.left + (target.offsetWidth - tooltip.offsetWidth) / 2;
    },
    hideTooltip() {
      const tooltip = document.querySelector('#tooltip-modal');
      tooltip.style.display = 'none';
    }
  }
};
</script>